var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureLists({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 7.07104,
    width: 10,
    height: 10,
    transform: "rotate(-45 0 7.07104)",
    fill: "#FF5349"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureLists);
export default __webpack_public_path__ + "static/media/featureLists.d615d42ed07e3f135a74077e01972892.svg";
export { ForwardRef as ReactComponent };